import { render, staticRenderFns } from "./customerIntendedForm.vue?vue&type=template&id=89885fda&scoped=true"
import script from "./customerIntendedForm.vue?vue&type=script&lang=js"
export * from "./customerIntendedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89885fda",
  null
  
)

export default component.exports